"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ReviewAnswersViewStyle = _interopRequireDefault(require("../css/ReviewAnswersViewStyle"));

var _AnswerOverview = _interopRequireDefault(require("./AnswerOverview"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReviewAnswersView = function ReviewAnswersView(_ref) {
  var viewData = _ref.viewData,
      scenarios = _ref.scenarios,
      appointmentTextareaValues = _ref.appointmentTextareaValues,
      setAppointmentTextareaValues = _ref.setAppointmentTextareaValues,
      setPdfContent = _ref.setPdfContent,
      printPdf = _ref.printPdf,
      currentSituations = _ref.currentSituations,
      setCurrentSituations = _ref.setCurrentSituations,
      deleteScenario = _ref.deleteScenario;
  (0, _react.useEffect)(function () {
    if (currentSituations && currentSituations.length < 3) {
      setCurrentSituations(currentSituations.filter(function (scenario) {
        return scenario.isSelected;
      }));
    }
  }, [scenarios]);
  (0, _react.useEffect)(function () {
    setPdfContent(String(document.querySelector('.scenario-review').outerHTML).replace(/(.webp)+/g, '.jpg').replace(/textarea/g, 'div'));
    setDataSelectedScenariosLength();
  }, [currentSituations, appointmentTextareaValues]);
  (0, _react.useEffect)(function () {
    typeof dataLayer !== 'undefined' ? dataLayer.push({
      'event': 'vpv',
      'vpv': "".concat(window.location.href, "/step5")
    }) : null;
  }, []);

  var handleGAevent = function handleGAevent() {
    typeof dataLayer !== 'undefined' ? dataLayer.push({
      'event': 'GAevent',
      'eventCategory': ' All Link & Button Clicks',
      'eventAction': 'Send to your audiologist',
      'eventLabel': window.location.href
    }) : null;
  };

  var setDataSelectedScenariosLength = function setDataSelectedScenariosLength() {
    var scenariosCounter = document.querySelector('[data-scenario-count]');
    var scenarioReviewHeader = document.querySelector('.scenario-review-header');

    if (scenariosCounter) {
      scenariosCounter.innerHTML = currentSituations.length;
    } else {
      if (scenarioReviewHeader) {
        scenarioReviewHeader.innerHTML = viewData === null || viewData === void 0 ? void 0 : viewData.reviewAnswersView.yourAnswersDescription.html.html.replace(/[0-9]+/, currentSituations.length);
      }
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_ReviewAnswersViewStyle["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenario-review"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenario-review-header",
    dangerouslySetInnerHTML: {
      __html: viewData === null || viewData === void 0 ? void 0 : viewData.reviewAnswersView.yourAnswersDescription.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenario-review-content ".concat(currentSituations && currentSituations.length > 3 ? 'align-to-left' : '')
  }, currentSituations.map(function (scenario, index) {
    return scenario.isSelected && /*#__PURE__*/_react["default"].createElement(_AnswerOverview["default"], {
      scenario: scenario,
      viewData: viewData === null || viewData === void 0 ? void 0 : viewData.answerOverview,
      key: index,
      index: index,
      reviewAnswersView: true,
      deleteScenario: currentSituations.length > 3 ? deleteScenario : false
    });
  })), currentSituations && currentSituations.length >= 3 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-flex-wrapper button-flex-wrapper--right"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "link link-plus",
    to: "overview"
  }, viewData === null || viewData === void 0 ? void 0 : viewData.buttons.addMoreScenariosButton.html.html)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper-header"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, viewData === null || viewData === void 0 ? void 0 : viewData.thankYouView.reasonLabel.html.html)), /*#__PURE__*/_react["default"].createElement("textarea", {
    placeholder: viewData === null || viewData === void 0 ? void 0 : viewData.thankYouView.reasonPlaceholder.html.html.trim(),
    onChange: function onChange(e) {
      return setAppointmentTextareaValues(_objectSpread(_objectSpread({}, appointmentTextareaValues), {}, {
        'reasonForVisit': e.currentTarget.value
      }));
    },
    value: appointmentTextareaValues.reasonForVisit
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper-header"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, viewData === null || viewData === void 0 ? void 0 : viewData.thankYouView.expectationsLabel.html.html)), /*#__PURE__*/_react["default"].createElement("textarea", {
    placeholder: viewData === null || viewData === void 0 ? void 0 : viewData.thankYouView.expectationsPlaceholder.html.html.trim(),
    onChange: function onChange(e) {
      return setAppointmentTextareaValues(_objectSpread(_objectSpread({}, appointmentTextareaValues), {}, {
        'visitExpectations': e.currentTarget.value
      }));
    },
    value: appointmentTextareaValues.visitExpectations
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-flex-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "save-button",
    to: "audiologist-email-form",
    onClick: function onClick(e) {
      return handleGAevent(e);
    }
  }, viewData === null || viewData === void 0 ? void 0 : viewData.buttons.sendButton.html.html), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "save-button",
    to: "downloading-answers",
    onClick: function onClick(e) {
      return printPdf(e);
    }
  }, viewData === null || viewData === void 0 ? void 0 : viewData.buttons.downloadButton.html.html)))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-flex-wrapper button-flex-wrapper--centered"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "overview",
    className: "save-button"
  }, viewData === null || viewData === void 0 ? void 0 : viewData.buttons.backButton.html.html))));
};

var _default = ReviewAnswersView;
exports["default"] = _default;